// opervex-frontend/src/pages/NotFoundPage.js

import { Link, useParams } from "react-router-dom";

const NotFoundPage = () => {
  const { tenantId } = useParams();

  return (
    <div className="container text-center mt-5">
      <h1 className="display-1 fw-bold text-danger">404</h1>
      <p className="lead">Oops! Página não encontrada.</p>
      <p className="text-muted">A página que você tentou acessar não existe ou foi movida.</p>
      <Link to={`/${tenantId}`} className="btn btn-primary mt-3">
        Voltar para o Início
      </Link>
    </div>
  );
};

export default NotFoundPage;
